import store from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setIsSaving', function setIsRemovingDomain(newValue) {
    store.isRemovingDomain = newValue;
    store.isDomainRemoved = true;
});
//# sourceMappingURL=setIsRemovingDomain.js.map